import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Mail, ArrowLeft, MailCheck } from "lucide-react";
import { Input } from "@/components/ui/input";

const API = process.env.REACT_APP_BACKEND_URL;

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error("Informe seu e-mail.");
    setLoading(true);
    try {
      await fetch(`${API}/api/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      setSent(true);
    } catch {
      toast.error("Não foi possível enviar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-br from-slate-900 via-slate-800 to-blue-950 px-5 py-10">
      <motion.div initial={{ opacity: 0, y: 18 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} className="w-full max-w-md">
        <div className="rounded-3xl border border-white/10 bg-white p-8 shadow-2xl">
          <div className="flex flex-col items-center text-center">
            <img src="/veloclin-logo.png" alt="VeloClin" className="h-16 w-auto" />
            <h1 className="mt-4 font-heading text-2xl font-extrabold tracking-tight text-slate-900">Recuperar senha</h1>
            <p className="mt-1 text-sm text-slate-500">Enviaremos um link de redefinição para o seu e-mail.</p>
          </div>

          {sent ? (
            <div data-testid="forgot-sent-message" className="mt-7 rounded-2xl border border-emerald-100 bg-emerald-50 p-5 text-center">
              <MailCheck className="mx-auto h-8 w-8 text-emerald-600" />
              <p className="mt-2 text-sm font-semibold text-slate-800">Verifique seu e-mail</p>
              <p className="mt-1 text-sm text-slate-500">
                Se houver uma conta com <span className="font-medium text-slate-700">{email}</span>, enviamos um link para redefinir a senha. O link expira em 1 hora.
              </p>
            </div>
          ) : (
            <form onSubmit={submit} className="mt-7 space-y-4">
              <div>
                <label className="text-xs font-semibold text-slate-600">E-mail cadastrado</label>
                <div className="relative mt-1.5">
                  <Mail className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
                  <Input data-testid="forgot-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="voce@clinica.com" className="border-slate-200 pl-9 focus-visible:ring-blue-600" />
                </div>
              </div>
              <button data-testid="forgot-submit-btn" type="submit" disabled={loading} className="w-full rounded-xl bg-blue-600 py-3.5 text-sm font-bold text-white shadow-[0_8px_24px_rgba(37,99,235,0.4)] transition-colors hover:bg-blue-700 disabled:opacity-60">
                {loading ? "Enviando..." : "Enviar link de redefinição"}
              </button>
            </form>
          )}

          <Link to="/login" data-testid="forgot-back-login" className="mt-6 flex items-center justify-center gap-1.5 text-sm font-semibold text-blue-600 hover:text-blue-700">
            <ArrowLeft className="h-4 w-4" /> Voltar para o login
          </Link>
        </div>
      </motion.div>
    </div>
  );
}
